import axios from 'axios';
import './axios-interceptor';

export default {
  async addFavorite(eventId: string) {
    return await axios.post(`myfav`, {
      eventId: eventId,
    });
  },
  async removeFavorite(eventId: string) {
    return await axios.put(`myfav`, {
      eventId: eventId,
    });
  },
  async getMyFavorite(param: any, searchParam: string) {
    return await axios.get(`myfav/list?limit=${param.limit}&${searchParam}`);
  },
};
